import { mapState } from "vuex";

export default {
  methods: {
    // Optional clientId parameter
    // Uses the user's clientId if not provided
    isOne10PointsEnabled(clientId = undefined) {
      const featureFlagEnabled = this.featureFlags["feature-one10-points"];
      if (!featureFlagEnabled) return false;

      if (clientId) {
        const client = (this.clients || []).find((c) => c.clientId === clientId);
        if (client) return client.one10PointsEnabled;
      }
      return this.userProfile.Client.one10PointsEnabled;
    },
  },
  computed: {
    ...mapState(["featureFlags", "userProfile", "clients"]),
  },
};
